import { render } from "./SearchContent.vue?vue&type=template&id=425e36fa"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"

import "./SearchContent.vue?vue&type=style&index=0&id=425e36fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__